import { Instance, SnapshotIn, types } from 'mobx-state-tree';

import CgRegion from '@common/models/CgRegions/CgRegion';

const CgCity = types.model('CgCity', {
	id: types.number,
	name_en: types.string,
	name_uk: types.string,
	c_g_region_id: types.number,
	region: types.maybeNull(CgRegion),
});

export default CgCity;

export interface ICgCityModel extends Instance<typeof CgCity> {}
export type ICgCitySnapshotIn = SnapshotIn<typeof CgCity>;
